import { useLayoutEffect } from "react";
import { isKickStaffEmail } from "@common/helpers/kickStaff";
import { useConstant } from "@hooks/useConstant";
import { getLocalTodayDateOnly } from "@helpers/date";
import { useUser } from "@hooks/useUser";
import type { DemoDataset } from "./busyClosesDemo.types";
import { useIsBusyClosesDemoStoredOn } from "./busyClosesDemoSwitch";
import { registerBusyClosesDemoDataset } from "./busyClosesDemoStore";

/** Whether the signed-in user is Kick staff, the only users who get the busy closes demo. */
export const useIsKickStaff = (): boolean => isKickStaffEmail(useUser()?.email);

/** Whether this browser has the busy closes demo on and the signed-in user is Kick staff. */
export function useIsBusyClosesDemoOn(): boolean {
    const isStoredOn = useIsBusyClosesDemoStoredOn();
    return useIsKickStaff() && isStoredOn;
}

/** Today and now, fixed for the mount so the fakes don't rebuild every render. */
export const useDemoClock = () =>
    useConstant(() => ({ today: getLocalTodayDateOnly(), now: Date.now() }));

/** Mounts a built dataset in the live store before paint, so its runs and viewers resolve on the first frame and tick only while the page is open. */
export const useRegisterDemoDataset = (dataset: DemoDataset | null) => {
    useLayoutEffect(
        () =>
            dataset === null
                ? undefined
                : registerBusyClosesDemoDataset(dataset),
        [dataset],
    );
};
